
const digest = 'e130a026e3b51148a5f7751edbfda08ed9c3cd7cd62eafa42af5c081dc9d5ef6';
const classes = {"wrapper":"_wrapper_18amh_1","iconWrapper":"_iconWrapper_18amh_7","bold":"_bold_18amh_14","addButton":"_addButton_18amh_17"};
const css = `._wrapper_18amh_1 {
  font-family: "Rubik", sans-serif;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_18amh_1 ._iconWrapper_18amh_7 {
  display: flex;
  flex-direction: row;
  gap: 7px;
  align-items: center;
  margin-top: 15px;
}
._wrapper_18amh_1 ._bold_18amh_14 {
  font-weight: 500;
}
._wrapper_18amh_1 ._addButton_18amh_17 {
  width: 100%;
  padding: 24px;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: 2px solid #eef0f4;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  color: #a7a7a7;
}
._wrapper_18amh_1 ._addButton_18amh_17:hover {
  color: #8992a6;
  border-color: #dde0e7;
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  